<template>
  <Modal id="edit-user" :modal="editUserModalRef" :steps="[{ id: 'edit-user', component: EditUserModalContent }]" />
</template>

<script setup lang="ts">
import EditUserModalContent from './edit-user-modal-content/edit-user-modal-content.vue'

import Modal from '@/features/ui/components/modal/modal.vue'
import { selectGetEditProfileModal } from '@/features/ui/store/modal/modal.selectors'
import modalsStore from '@/features/ui/store/modal/modal.store'

const editUserModalRef = selectGetEditProfileModal(modalsStore)
</script>
